import {
  amountWithAbbreviation,
  amountWithPrecisionAsRequiredAndComma,
} from '~/javascripts/utils/numberFormatter';
import { observer } from 'mobx-react';

const UserStats = observer(
  ({ _currentUser, projectCountryCount, userProjects }) => (
    <div className='stat-section flex flex-row border border-grey-70 border-l-0 border-b-0 border-r-0 xl-border-t-0 py-0 justify-between xl-justify-end'>
      <div className='flex flex-col items-center justify-center w-1/2 py-7 xl-p-8 text-center border border-grey-70 border-t-0 border-b-0 border-r-0'>
        <h1 className='heading-l text-cw-white'>
          <span className='show-for-mobile-only uppercase'>
            {userProjects?.features.length > 0
              ? amountWithAbbreviation(userProjects?.features.length)
              : '--'}
          </span>
          <span className='show-for-medium-up'>
            {userProjects?.features.length > 0
              ? amountWithPrecisionAsRequiredAndComma(
                  userProjects?.features.length
                )
              : '--'}
          </span>
        </h1>
        <p className='body-2xs text-cw-white show-for-mobile-only'>
          water projects
        </p>
        <p className='body-xs text-cw-white show-for-medium-up'>
          water projects
        </p>
      </div>
      <div className='flex flex-col items-center justify-center w-1/2 p-0 xl-p-8 text-center border border-grey-70 border-t-0 border-b-0 border-r-0'>
        <h1 className='heading-l text-cw-white'>
          {projectCountryCount > 0
            ? amountWithPrecisionAsRequiredAndComma(projectCountryCount)
            : '--'}
        </h1>
        <p className='body-2xs text-cw-white show-for-mobile-only'>countries</p>
        <p className='body-xs text-cw-white show-for-medium-up'>countries</p>
      </div>
    </div>
  )
);
export default UserStats;
